export const allFileUploadSelectFields = `id,
  caption,
  category,
  content_type_id,
  space_id,
  venue_id,
  event_space_list_membership_id,
  create_source,
  created_at,
  filename,
  mime_type,
  image_hash,
  image_vibe_score,
  hash,
  object_id,
  sub_category,
  update_author_id,
  updated_at,
  upload,
  url,
  file_filepermission(
    id,
    expired_at,
    permission_scope,
    shared_by_id,
    event_email_id,
    event_space_list_membership_id,
    space_id,
    venue_id
  )
`

export const venueTrustSignalSelectFields =
  'id,applied_at,create_source,created_at,deleted_at,rating,result_json,signal_url,source_domain,trust_signal_source_id,update_author_id,updated_at,venue_address,venue_description,venue_id,venue_name,venue_place_id'

export const inquiryEmailSelectFields = 'id,sent_at,space_id,user_id,create_source,created_at,updated_at,event_id,update_author_id,venue_id,user_space_id,delivery_method'
